(function () {
  'use strict';
  function init(scope) {
    scope.querySelectorAll('[data-stackhouse-native-product]').forEach(function (container) {
      if (container.dataset.nativeProductReady) return;
      var form = container.querySelector('.product-purchase-form');
      var input = form && form.querySelector('select[name="id"]');
      var selectors = container.querySelector('.option-selectors');
      var data = document.getElementById('ccProductJson-' + container.dataset.productId);
      if (!input || !selectors || !data) return;
      var product;
      try { product = JSON.parse(data.textContent); } catch (_) { return; }
      var options = Array.from(selectors.querySelectorAll('select'));
      if (!options.length) return;
      container.dataset.nativeProductReady = 'true';
      // The speed layout omits theme.js. Bind the same visible options there.
      // In the full layout, OptionManager already owns this interaction.
      input.hidden = true;
      input.style.display = 'none';
      if (container.classList.contains('theme-init')) return;
      function sync(updateHistory) {
        var values = options.map(function (option) { return option.value; });
        var variant = product.variants.find(function (candidate) {
          return candidate.options.length === values.length && candidate.options.every(function (value, i) { return value === values[i]; });
        });
        input.value = variant ? String(variant.id) : '';
        var available = Boolean(variant && variant.available);
        form.querySelectorAll('[type="submit"]').forEach(function (button) {
          button.disabled = !available;
          var label = button.querySelector('.czd, .button-text');
          if (label) label.textContent = available ? 'Order Now' : (variant ? 'Sold out' : 'Unavailable combination');
        });
        var price = container.querySelector('.current-price');
        if (price) price.textContent = input.selectedOptions[0] ? input.selectedOptions[0].dataset.price : 'Unavailable';
        var wasPrice = container.querySelector('.was-price');
        if (wasPrice) wasPrice.hidden = !variant || !(variant.compare_at_price > variant.price);
        container.querySelectorAll('input[name="id"]').forEach(function (field) { field.value = input.value; });
        input.dispatchEvent(new CustomEvent('change', { bubbles: true, detail: { variant: variant || false, selectedOptions: values } }));
        if (updateHistory && variant) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState(window.history.state, '', url);
        }
        return available;
      }
      selectors.addEventListener('change', function () { sync(true); });
      form.addEventListener('submit', function (event) { if (!sync(false)) event.preventDefault(); }, true);
      sync(false);
    });
  }
  init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
